import { AnyObject } from '@mri/types';

class StorageManager {
  getString(key: string): string | null {
    return localStorage.getItem(key);
  }

  getJson<T = AnyObject>(key: string): T | null {
    const data = this.getString(key);

    try {
      if (data) return JSON.parse(data);
    } catch (e) {
      return null;
    }
    return null;
  }

  getNumber(key: string): number | null {
    const data = this.getString(key);
    if(!data) return null;

    return Number.parseFloat(data);
  }

  set( key: string, data: AnyObject): void{
    const convert = typeof data === 'string'? data : JSON.stringify(data);

    return localStorage.setItem(key, convert);
  }
}

export const storageManager = new StorageManager();
